import { pageRowsBy } from './pageRows';
import { searchRowsBy } from './searchRows';
import { sortRowsBy } from './sortRows';
import type { PaginationInfo } from './types';
import { useGridUrlState, type GridUrlStateConfig } from './useGridUrlState';

const DEFAULT_PER_PAGE = 25;

/**
 * Answers the grid's own URL state for rows the page holds in full: search,
 * then sort, then page — the order the server applies them, so a client-side
 * grid and a server-paged one behave the same.
 *
 * Routes that page server-side answer that state in SQL and hand `DataGrid`
 * the slice directly; this is for aggregate reports and small config lists.
 */
export function useGridRows<TRow>(
  rows: TRow[],
  config: GridUrlStateConfig<TRow> & { perPage?: number },
): { rows: TRow[]; pagination: PaginationInfo } {
  const { sort, search, page } = useGridUrlState(config);
  const searched = searchRowsBy(rows, search, config.columns);
  const sorted = sortRowsBy(searched, sort, config.columns);
  return pageRowsBy(sorted, page, config.perPage ?? DEFAULT_PER_PAGE);
}
